<template>
  <Modal
    :title="title"
    :show-modal="title === 'Create' || title === 'Edit'"
    @close="$emit('close')"
  >
    <div class="mb-4">
      <ChoiseCompany
        @selected:company="($event) => $emit('on-selected-company', $event)"
        :options="companies"
        :dataCompany="company"
      />
    </div>
    <Input
      class="!mb-4"
      label="Title"
      :label-top="true"
      placeholder="Title"
      :value="taskName"
      :input_class="'h-10'"
      @input="$emit('update:taskName', $event)"
    />
    <div class="grid grid-cols-2 gap-4">
      <div class="flex flex-col">
        <label class="w-full text-sm text-gray-400 min-w-max md:w-1/5"
          >Start Date</label
        >
        <DatePicker
          v-model="taskStartDate"
          :auto-position="false"
          position="left"
          :enable-time-picker="false"
          placeholder="Selected start date"
          :format="($event) => formatDate($event)"
          @update:model-value="selectedStartDate"
        />
      </div>
      <div class="flex flex-col">
        <label class="w-full text-sm text-gray-400 min-w-max md:w-1/5"
          >End date</label
        >
        <DatePicker
          v-model="tastEndDate"
          :auto-position="false"
          position="left"
          :enable-time-picker="false"
          placeholder="Selected end date"
          :format="($event) => formatDate($event)"
          @update:model-value="selectedEndDate"
        />
      </div>
      <div class="flex flex-col">
        <label class="w-full text-sm text-gray-400 min-w-max md:w-1/5"
          >Project Users</label
        >
        <Multiselect
          v-model="taskUsers"
          mode="tags"
          :close-on-select="false"
          :searchable="true"
          :create-option="true"
          :options="employees"
          :placeholder="'Select user'"
          @select="selectUser"
          @deselect="removeUser"
        />
      </div>
      <Input
        :type="'number'"
        label="Estimated Hours"
        :label-top="true"
        :value="estimate"
        class="!mb-0"
        :input_class="'h-10'"
        @input="$emit('update:estimate', $event)"
      />
      <Select
        v-if="id !== null"
        label="Status"
        :label-top="true"
        :options="listStatus"
        :value="taskStatus"
        property="label"
        @change="$emit('update:status', $event)"
        select_property="value"
      />
    </div>
    <div class="flex flex-col mt-4">
      <label class="w-full text-sm text-gray-400 min-w-max md:w-1/5"
        >Description</label
      >
      <QuillEditor
        ref="editorDescription"
        theme="snow"
        :content="taskDescription"
        :content-type="'html'"
        @text-change="updateDescription"
        class="h-32"
      />
    </div>
    <div class="flex flex-col mt-4 gap-y-2" v-if="id !== null">
      <label class="w-full text-sm text-gray-400 min-w-max md:w-1/5"
        >Progress</label
      >
      <Slider v-model="taskProgress" @slide="slideProgress" />
    </div>
    <template v-slot:footer>
      <section class="flex flex-row justify-end gap-x-2 w-52">
        <Button
          class="w-24 py-2 text-white bg-gray-400 rounded-md"
          @click="$emit('close')"
        >
          Close
        </Button>
        <Button
          class="w-24 py-2 text-white bg-green-500 rounded-md"
          :disabled="disabledSubmit"
          @click="$emit('on-submit')"
        >
          {{ id !== null ? "Add" : "Update" }}
        </Button>
      </section>
    </template>
  </Modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import Input from "@/components/Input.vue";
import Multiselect from "@vueform/multiselect";
import { QuillEditor } from "@vueup/vue-quill";
import Slider from "@vueform/slider";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import DatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import ChoiseCompany from "@/components/ChoiseCompany.vue";
import Select from "@/components/Select/index.vue";
import moment from "moment";

export default {
  name: "ModalCreateTask",
  components: {
    Modal,
    Input,
    DatePicker,
    Multiselect,
    QuillEditor,
    Slider,
    Select,
    ChoiseCompany,
  },
  props: {
    id: {
      type: String,
      required: true,
      default: null,
    },
    title: {
      Type: String,
      required: true,
    },
    companies: {
      type: Array,
      required: true,
    },
    taskName: {
      type: String,
      required: true,
      default: "",
    },
    company: {
      type: String,
      required: true,
      default: "",
    },
    startDate: {
      type: String,
      required: true,
      default: "",
    },
    endDate: {
      type: String,
      required: true,
      default: "",
    },
    Users: {
      type: String,
      required: true,
      default: "",
    },
    estimate: {
      type: [Number, String],
      required: true,
      default: "0",
    },
    users: {
      type: Array,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    employees: {
      type: Array,
      required: true,
    },
    progress: {
      type: Number,
      required: true,
      default: 0,
    },
    status: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      date: "",
      customPosition: { top: 0, left: 0 },
      value: 0,
      listStatus: [
        { value: "not_started", label: "Not Started" },
        { value: "ongoing", label: "Ongoing" },
        { value: "passed", label: "Passed" },
        { value: "stoped", label: "Stoped" },
      ],
      taskStartDate: this.startDate,
      tastEndDate: this.endDate,
      taskUsers: this.users,
      taskDescription: this.description,
      taskProgress: this.progress,
      taskStatus: this.status,
    };
  },
  // watch: {
  //   description: {
  //     handler: function (value) {
  //       this.$refs.editorDescription.root.innerHTML = value;
  //     },
  //     deep: true,
  //   },
  // },
  computed: {
    // disabledSubmit() {
    //   if (
    //     this.taskName.length &&
    //     this.company !== null &&
    //     this.taskStartDate.length &&
    //     this.tastEndDate.length &&
    //     this.taskUsers.length &&
    //     this.estimate !== "0" &&
    //     this.description.length
    //   ) {
    //     return false;
    //   }
    //   return true;
    // },
  },
  methods: {
    selectedStartDate(value) {
      this.$emit("update:startDate", value);
    },
    selectedEndDate(value) {
      this.$emit("update:endDate", value);
    },
    selectUser() {
      this.$emit("update:users", this.taskUsers);
    },
    removeUser() {
      this.$emit("update:users", this.taskUsers);
    },
    updateDescription() {
      this.$emit("update:description", this.$refs.editorDescription.getHTML());
    },
    slideProgress(value) {
      this.$emit("update:progress", value);
    },
    formatDate(value) {
      if (value) {
        return moment(value).format("DD/MM/YYYY");
      }
      return "";
    },
  },
};
</script>

<style lang="scss">
.dp__action_button.dp__action_select,
button,
[type="button"],
[type="reset"],
[type="submit"] {
  @apply bg-blue-300;
}

.multiselect-tag {
  @apply bg-white text-gray-400 #{!important};
}

.slider-connect {
  @apply bg-blue-500 #{!important};
}

.slider-tooltip {
  @apply bg-blue-500 #{!important};
}
</style>

<style src="@vueform/multiselect/themes/default.css"></style>
<style src="@vueform/slider/themes/default.css"></style>
<style src="@vueform/slider/themes/default.css"></style>
